import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { BaseService } from 'src/app/core/base/base.service';
import { RestService } from 'src/app/core/service/rest.service';
import { CommonPatientDataModel } from 'src/app/model/common/patient-data';
import { GeneralDetailModel } from 'src/app/model/general/detail';
import { generalConsultActions } from 'src/app/store/general/general.action';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeneralConsultWrapperService extends BaseService {
  constructor(protected store: Store<any>, protected rest: RestService) {
    super();
  }

  loadConsultDetail = (turn: number): Observable<GeneralDetailModel> =>
    this.rest
      .get({
        url: `${environment.endpoints.general}/detail/{turn}`,
        urlParams: { turn },
      })
      .pipe(
        map((detail) => {
          if (detail) {
            return detail;
          }
          return {} as GeneralDetailModel;
        })
      );

  loadPatientData = (patient: number): Observable<CommonPatientDataModel> =>
    this.rest
      .get({
        url: `${environment.endpoints.common}/patient-data/{patient}`,
        urlParams: { patient },
      })
      .pipe(
        map((detail) => {
          if (detail) {
            return detail;
          }
          return {
            patient,
          } as CommonPatientDataModel;
        })
      );

  isSaving = (): Observable<boolean> =>
    this.store.select('general', 'consult', 'saving');

  save = (
    turn: number,
    body: GeneralDetailModel
  ): Observable<GeneralDetailModel> =>
    this.rest
      .post({
        url: `${environment.endpoints.general}/detail`,
        body: { ...body, turn },
      })
      .pipe(
        tap(
          () => this.addToSaved(),
          () => this.addToSaved()
        )
      );

  savePatientData = (
    body: CommonPatientDataModel
  ): Observable<CommonPatientDataModel> =>
    this.rest
      .post({
        url: `${environment.endpoints.common}/patient-data`,
        body,
      })
      .pipe(
        tap(
          () => this.addToSaved(),
          () => this.addToSaved()
        )
      );

  addToSaved = (value: number = 1) =>
    this.store.dispatch(generalConsultActions.addToSavedAction({ value }));
}
